import { api } from './client';

export type ShareResourceType = 'project' | 'app';

export interface ShareInvitation {
  id: string;
  resource_type: ShareResourceType;
  resource_id: string;
  resource_name: string;
  email: string;
  role: string;
}

export interface ResourceCollaborator {
  email: string;
  role: string;
  status: 'active' | 'pending';
  joined_at?: string;
  expires_at?: string;
  id?: string;
}

export interface ResourceCollaboratorsResponse {
  owner: { name: string; email: string; role: string };
  members: ResourceCollaborator[];
  pending_invitations: ResourceCollaborator[];
  viewer_is_owner?: boolean;
}

export const shareInviteService = {
  async invite(
    resourceType: ShareResourceType,
    resourceId: string,
    email: string,
    role: 'viewer' | 'editor' = 'viewer'
  ): Promise<ShareInvitation> {
    const path =
      resourceType === 'project'
        ? `/projects/${resourceId}/share-invitations`
        : `/apps/${resourceId}/share-invitations`;
    const response = await api.post<{ invitation: ShareInvitation }>(path, { email, role });
    return response.data.invitation;
  },

  async accept(invitationId: string): Promise<ShareInvitation> {
    const response = await api.post<{ invitation: ShareInvitation }>(
      `/share-invitations/${invitationId}/accept`
    );
    return response.data.invitation;
  },

  async getProjectCollaborators(projectId: string): Promise<ResourceCollaboratorsResponse> {
    const response = await api.get<ResourceCollaboratorsResponse>(
      `/projects/${projectId}/collaborators`
    );
    return response.data;
  },

  async cancelProjectInvitation(projectId: string, invitationId: string): Promise<void> {
    await api.delete(`/projects/${projectId}/share-invitations/${invitationId}`);
  },
};
